// @flow
import React, { Component } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { windowWrapper } from '@clubmed/utils';

import { themes } from './Countdown.themes';

const UNITS = ['days', 'hours', 'minutes', 'seconds'];

export type CountdownProps = {|
  className?: string,
  color?: Colors,
  dateTimeEnd: *,
  days: string,
  hours: string,
  minutes: string,
  seconds: string,
  size?: string,
  theme?: string,
  dataTestId?: string,
  bgColor?: string,
|};

type State = {
  timeRemaining: moment$MomentDuration | 0,
};

function getStateFromProps({ dateTimeEnd }) {
  const now = moment();
  return {
    timeRemaining: now.isBefore(dateTimeEnd) ? moment.duration(moment(dateTimeEnd).diff(now)) : 0,
  };
}

export class Countdown extends Component<CountdownProps, State> {
  static defaultProps = {
    size: 'large',
    theme: 'default',
  };

  rafID: ?number;

  constructor(props: CountdownProps) {
    super(props);
    this.state = getStateFromProps(props);
  }

  static getDerivedStateFromProps(nextProps: CountdownProps) {
    return getStateFromProps(nextProps);
  }

  componentDidMount() {
    if (this.shouldDisplay()) {
      this.rafID = windowWrapper.requestAnimationFrame(this.tick);
    }
  }

  componentWillUnmount() {
    windowWrapper.cancelAnimationFrame(this.rafID);
  }

  tick = () => {
    const { dateTimeEnd } = this.props;
    const timeRemaining = moment.duration(moment(dateTimeEnd).diff(moment()));

    this.setState({ timeRemaining }, () => {
      if (timeRemaining.asSeconds() > 0) {
        this.rafID = windowWrapper.requestAnimationFrame(this.tick);
      }
    });
  };

  shouldDisplay(): boolean {
    const { timeRemaining } = this.state;
    // $FlowFixMe
    return timeRemaining > 0 && timeRemaining.months() === 0;
  }

  render() {
    if (!this.shouldDisplay()) return null;

    const { className, theme, dataTestId } = this.props;
    const { timeRemaining } = this.state;

    const { thItem, thLabel, thRoot, thValue, thValueStyle } = themes[theme](this.props);

    return (
      <div className={classnames(className, thRoot)} role="timer" data-testid={dataTestId}>
        {UNITS.map(unit => {
          // $FlowFixMe
          const current = timeRemaining[unit]();
          const currentTime = current < 10 ? `0${current}` : current;

          return (
            <div className={thItem} key={unit}>
              <div className={thValue} style={thValueStyle}>
                {currentTime}
              </div>
              <div className={thLabel}>{this.props[unit]}</div>
            </div>
          );
        })}
      </div>
    );
  }
}
